import { lazy } from 'react';
import MainLayout from 'layouts/MainLayout';

const LandingPage = lazy(() => import('../pages/LandingPage'));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage'));
const ReportPage = lazy(() => import('../pages/ReportPage'));

const routes = [{
    layout: MainLayout,
    routes: [{
        path: '/agents/aeo-analyst/:agentId',
        element: LandingPage,
        exact: true,
        analytics: { name: ["Agente", "AEO Analyst"] },
    }, {
        path: '/agents/aeo-analyst/:agentId/analyses/:analysisId',
        element: AnalysisPage,
        exact: true,
        analytics: { name: ["Agente", "AEO Analyst", "Analisi"] },
    }, {
        path: '/agents/aeo-analyst/:agentId/analyses/:analysisId/report',
        element: ReportPage,
        exact: true,
        analytics: { name: ["Agente", "AEO Analyst", "Report"] },
    }]
}];

export default routes;
